import { inject, observer } from 'mobx-react'
import React, { forwardRef } from 'react'
import { toast } from 'react-toastify'
import { Button, Popup } from 'semantic-ui-react'
import styled from 'styled-components'
import { COLOR_GREEN } from '../../../../core/constants'
import { showConversation } from './Conversations'

const MoreConversationsBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 4em;
  margin: 0.5em 0.2em 0.2em 0.2em;
  padding: 0.2em;
  
  background: ${props => props.isDisabled ?  '#567180' : '#3b5998'};
  opacity: ${props => props.isDisabled ? '0.45' : '1'};
  color: white;
  font-weight: bold;
  
  border-radius: 0.5em;
  
  cursor: ${props => props.isDisabled ? 'default' : 'pointer'};
  user-select: none;
  
  ${props => !props.isDisabled && `
    &:hover {
      background-color: #304d8a;
    }
  `}
`

const ReloadConversationsContainer = styled.div`
  padding: 0.2em;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2.4em;
  .text-number {
    font-size: 18px;
    color: ${COLOR_GREEN};
    cursor: help;
  }
`

export const MoreConversationsButton = inject('store', 'actions')(observer(forwardRef(({ store, actions }, ref) => {
  const extraConversationsActive = store.agent.extraConversationsActive
  const conversations = store.conversationsSorted.filter(showConversation)
  const conversationsLength = conversations?.length || 0
  const isPendingConversations = store.isPendingConversations

  const handleMoreConversations = async() => {
    const errorHandler = ([, err]) => {
      if(err && err.statusCode) {
        switch (err.statusCode) {
          case 404:
            actions.agent.cancelMoreConversations()
            toast.info('No conversations left in queue.')
            break
          case 429:
            actions.agent.cancelMoreConversations()
            toast.info('Maximum number of extra conversations reached.')
            break
        }
      }
    }
    if (!store.agent.extraConversationsActive) {
      actions.agent.queueMoreConversationsRequest(10, errorHandler)
    }
    else {
      actions.agent.cancelMoreConversations()
    }
  }

  const handleRefetchConversations = () => {
    actions.chat.fetchAgentConversations()
  }
  
  return (
    <>
    <MoreConversationsBtn ref={ref} onClick={handleMoreConversations} isDisabled={isPendingConversations}>
      { extraConversationsActive ? 'Requesting more conversations...' : 'Request more conversations' }
    </MoreConversationsBtn>
      <ReloadConversationsContainer>
        <Popup content='Refresh the list'
          trigger={
            <Button icon='refresh'
              disabled={isPendingConversations}
              onClick={handleRefetchConversations}
            />
          }
        />
        <Popup
          content='Number of conversations'
          trigger={<div className='text-number'>{conversationsLength}</div>}
        />
      </ReloadConversationsContainer>
    </>
  )
})))
